import React from 'react';
import { Outlet } from 'react-router-dom';
import { Menu, Bell, User, Settings, LogOut, Search } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
// import { ThemeSwitcher } from '@/components/common/ThemeSwitcher';
import { EnhancedSidebar } from '@/components/common/EnhancedSidebar';
import { DashboardContext } from '@/contexts/DashboardContext';
import { useCurrentUser, useUI, useAppDispatch } from '@/hooks/redux';
import { toggleSidebar } from '@/store/slices/uiSlice';
// import { useLogoutMutation } from '@/store/api/authApi';
import { cn } from '@/utils';

export function DashboardLayout() {
  const user = useCurrentUser();
  const dispatch = useAppDispatch();
  const { sidebarOpen } = useUI();

  const handleLogout = async () => {
    try {
      // await logout().unwrap();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <DashboardContext.Provider value={true}>
      <div className="min-h-screen bg-background">
        {/* Enhanced Sidebar */}
        <EnhancedSidebar isOpen={sidebarOpen} onToggle={() => dispatch(toggleSidebar())} />

        {/* Main Content */}
        <div className={cn('transition-all duration-300', sidebarOpen ? 'lg:ml-80' : 'lg:ml-16')}>
          {/* Top Navigation */}

          {/* Page content */}
          <main className="flex-1 min-w-0 overflow-x-clip p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </DashboardContext.Provider>
  );
}
